import React, { Component } from "react";
import BackButton from "../../component/BackButton";

class ProjectDetailFood extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <BackButton />
          <div className="sm-space"></div>
          <div className="project-title text-left">Food Sharer</div>
          <div className="sm-space"></div>
          <div className="row">
            <div className="project-info col-lg-3 col-sm-12">
              <div className="project-subheader">Project Summary</div>
              <div className="project-subheader-detail">
                <b>Client: </b>
                Methodology and Interaction Design Final Project
                <div className="sm-space"></div>
                <b>Role: </b>
                User Researcher
                <div className="sm-space"></div>
                <b>Technology: </b>
                Sketch, Invision
                <div className="sm-space"></div>
              </div>
            </div>
            <div className="project-description col-lg-9 col-sm-12">
              <p>
                Food Sharer is a proposed digital platform designed to
                facilitate collaboration between food bank staff and charitable
                organizations in Sweden. The primary goal of the platform is to
                reduce food waste by improving communication, coordination, and
                resource distribution across organizations involved in food
                sharing and donation initiatives.
                <div className="space"></div>
                <div className="project-subheader-summary">Design Vision</div>
                <p className="design-vision">
                  The initial concept for this project stemmed from the
                  overarching theme of sustainability, which was assigned as
                  part of the course framework. After a brief group discussion
                  of four members, we collectively decided to focus on the issue
                  of waste management. To narrow the scope, we explored various
                  categories of waste and conducted field observations in
                  grocery stores to better understand real-world challenges.
                  From these insights, we identified food waste as a critical
                  area with significant environmental and social impact. Our
                  goal was to design an online platform that provides an
                  intuitive and efficient user experience, enabling users to
                  actively participate in reducing food waste through better
                  coordination and awareness.
                </p>
                <div className="space"></div>
                <div className="project-subheader-summary">
                  Ethnographic Observation
                </div>
                <p className="ethnographic-observation">
                  Grocery stores are among the largest contributors to food
                  waste, primarily due to products approaching their expiration
                  dates. To gain deeper insights into this issue, we conducted
                  field visits to three major grocery chains in Stockholm — ICA,
                  Lidl, and Willys. Through these visits, we discovered that
                  Stockholm already has a well-established food redistribution
                  system supported by Matbanken, a food bank organization that
                  collects and redistributes nearly expired but still consumable
                  products. This finding provided valuable context for
                  understanding existing infrastructures and identifying
                  opportunities for improvement in the coordination between
                  grocery stores and charitable organizations.
                </p>
                <div className="space"></div>
                <div className="project-subheader-summary">Interview</div>
                <p className="interview">
                  To gain a comprehensive understanding of the existing food
                  redistribution process, we conducted field visits and
                  interviews with both grocery store representatives and
                  Matbanken staff. Through these interviews, we identified the
                  involvement of an additional key stakeholder — charitable
                  organizations that receive food supplies directly from
                  Matbanken. The discussions revealed a three-party relationship
                  between grocery stores, Matbanken, and charity organizations.
                  This ecosystem formed the foundation for our design
                  exploration, highlighting the communication flow,
                  dependencies, and challenges that occur throughout the
                  food-sharing process.
                </p>
                <div className="space"></div>
                <div className="project-subheader-summary">
                  Understanding Design Dillemas
                </div>
                <p className="design-dillemas">
                  Our research uncovered several inefficiencies and
                  communication gaps within the existing food redistribution
                  system. Matbanken functions not only as a receiver of surplus
                  food from grocery stores but also as a temporary storage
                  facility before unclaimed items are discarded. One major
                  limitation identified was the lack of transparency and
                  accessibility in the current digital system. The platform did
                  not provide real-time information about food items approaching
                  expiration, preventing charity organizations and food bank
                  clients from making timely and informed decisions. Currently,
                  charity organizations are notified via phone only after
                  Matbanken receives the food from grocery stores. However, they
                  have limited visibility into the actual inventory available.
                  Although Matbanken employs an internal system, it remains
                  partially integrated, with several procedures—such as
                  scheduling pickup times and selecting available food
                  items—still being handled manually via phone calls. These
                  challenges underscore the need for a more streamlined,
                  transparent, and interconnected digital platform to enhance
                  coordination and reduce avoidable food waste.
                </p>
                <div className="space"></div>
                <div className="project-subheader-summary">Lo-Fi Design</div>
                <div className="project-image">
                  <img
                    className="cover"
                    src={require("../../assets/images/lofi-foodbank.png")}
                    alt="cover-food-bank"
                  />
                  <p>Paper prototype, brainstorming ideas</p>
                </div>
                <p className="lofi-design">
                  After identifying the key features and functional requirements
                  of the platform, we began the ideation and prototyping phase
                  by creating low-fidelity paper prototypes. Each team member
                  contributed individual design concepts, which were then tested
                  internally to evaluate usability and interaction flow. Through
                  iterative testing and group discussions, we consolidated our
                  insights to arrive at the most effective and user-friendly
                  layout. Once the team reached consensus on the design
                  direction, we developed a refined paper prototype and
                  conducted external usability testing with participants outside
                  the project team. This process helped validate the clarity of
                  navigation, task flow, and feature placement before moving on
                  to higher-fidelity digital prototyping.
                </p>
                <div className="space"></div>
                <div className="project-subheader-summary">Hi-Fi Design</div>
                <div className="project-image">
                  <img
                    className="cover"
                    src={require("../../assets/images/hifi-foodbank.png")}
                    alt="cover-food-bank"
                  />
                  <p>High fidelity prototype</p>
                </div>
                <div className="space"></div>
                <div className="project-subheader-summary">
                  Usability Testing
                </div>
                <p className="usability-testing">
                  Upon completing the high-fidelity prototype, we conducted
                  usability testing with participants who closely matched our
                  target user personas. The goal was to evaluate how effectively
                  the design addressed real user needs, focusing on task
                  efficiency, navigation clarity, and overall usability.
                  Feedback from these sessions provided valuable insights for
                  further refinement of the interface and interaction flow.
                </p>
                <div className="project-image">
                  <img
                    className="cover"
                    src={require("../../assets/images/testing-foodbank.png")}
                    alt="cover-food-bank"
                  />
                  <p>User testing</p>
                </div>
                <div className="space"></div>
                <div className="project-subheader-summary">
                  Design Challenge
                </div>
                <p className="design-challenge">
                  Initially, our team aimed to address all identified issues
                  within a single unified platform. However, early design
                  iterations revealed that this approach was too broad and
                  complex to implement effectively. Through reflection and
                  feedback, we recognized the importance of narrowing the
                  project scope and focusing on one key problem area to create a
                  more impactful solution. The final design concept centered on
                  developing an e-commerce–like platform that enables charity
                  organizations and Matbanken customers to efficiently place and
                  manage food orders online. With this system, charity
                  organizations no longer need to make phone calls to verify
                  food availability or schedule pick-ups, while customers can
                  avoid long waiting times at the food bank. This improvement
                  directly contributes to reducing food waste, as it optimizes
                  distribution and minimizes excess storage. In addition, we
                  proposed an enhancement to Matbanken’s existing website. While
                  the current system records incoming products, it lacks
                  functionality for tracking items by expiration date. We
                  suggested adding an “expiry date” column and a “will expire
                  today” category to help staff manage inventory more
                  proactively and prevent unnecessary waste. A notable challenge
                  during the testing phase was the limited access to Matbanken
                  staff for usability evaluation. To address this, we conducted
                  tests with participants who shared similar work patterns, such
                  as factory employees and students with relevant experience.
                  This approach allowed us to gather meaningful feedback that
                  informed further design refinements while maintaining
                  contextual relevance.
                </p>
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProjectDetailFood;
